import { useState } from "react";
import OrgDataTransfer, {
  Organization,
  TransferResult,
} from "./OrgDataTransfer";
import {
  useTransferOrganizationDataMutation,
  TransferOrganizationDataMutation,
  OrganizationsForStageDocument,
} from "../../../graphql/generated";
import { fetcher } from "../../../graphql/fetcher";

export default function OrgDataTransferContainer() {
  const [isTransferring, setIsTransferring] = useState(false);

  // Transfer mutation
  const transferMutation = useTransferOrganizationDataMutation();

  const handleFetchOrganizationsForStage = async (
    stage: string
  ): Promise<Organization[]> => {
    const result = await fetcher<any, any>(OrganizationsForStageDocument, {
      stage,
    })();

    return (
      result.organizationsForStage?.map((org: any) => ({
        _id: org._id || "",
        _organization: org._organization || "",
        name: org.name,
        dotNumber: org.dotNumber,
      })) || []
    );
  };

  const handleTransfer = async (
    sourceOrgId: string,
    sourceStage: string,
    targetOrgId: string,
    targetStage: string,
    deleteExistingData?: boolean
  ): Promise<TransferResult> => {
    setIsTransferring(true);
    try {
      const result = await transferMutation.mutateAsync({
        input: {
          sourceOrganizationId: sourceOrgId,
          sourceStage: sourceStage,
          targetOrganizationId: targetOrgId,
          targetStage: targetStage,
          deleteExistingData: deleteExistingData || false,
        },
      });

      return {
        success: result.transferOrganizationData.success,
        message: result.transferOrganizationData.message,
        transferredCollections:
          result.transferOrganizationData.transferredCollections.map(
            (
              collection: TransferOrganizationDataMutation["transferOrganizationData"]["transferredCollections"][number]
            ) => ({
              collectionName: collection.collectionName,
              recordCount: collection.recordCount,
              success: collection.success,
              error: collection.error,
            })
          ),
        totalRecordsTransferred:
          result.transferOrganizationData.totalRecordsTransferred,
        duration: result.transferOrganizationData.duration,
        timestamp: result.transferOrganizationData.timestamp,
      };
    } finally {
      setIsTransferring(false);
    }
  };

  return (
    <OrgDataTransfer
      onFetchOrganizationsForStage={handleFetchOrganizationsForStage}
      onTransfer={handleTransfer}
      isTransferring={isTransferring}
    />
  );
}
